import Link from 'next/link';
import { memo, useCallback } from 'react';

import { useTrackSidebarInteraction } from '@air/analytics';
import { InsightsChartIcon } from '@air/next-icons';

// import { Badge } from '@air/primitive-badge';

import { WorkspaceSidebarNavigationItem } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarNavigationItem';
import { Routes } from '~/constants/routes';
import { useRouterSelector } from '~/hooks/useRouterSelector';
export const WorkspaceSidebarCreativePerformance = memo(() => {
  const isActive = useRouterSelector((location) => location.pathname === Routes.creativePerformance);
  const { trackSidebarInteraction } = useTrackSidebarInteraction();

  const onClick = useCallback(() => {
    trackSidebarInteraction({ action: 'link_click', type: 'creative_performance' });
  }, [trackSidebarInteraction]);

  return (
    <WorkspaceSidebarNavigationItem asChild data-selected={isActive} onClick={onClick}>
      <Link href={{ pathname: Routes.creativePerformance }}>
        <InsightsChartIcon className="size-4 shrink-0" />
        <span className="truncate">Creative performance</span>
        {/* <Badge appearance="pill" color="grey" size="small" className="shrink-0">
          BETA
        </Badge> */}
      </Link>
    </WorkspaceSidebarNavigationItem>
  );
});

WorkspaceSidebarCreativePerformance.displayName = 'WorkspaceSidebarCreativePerformance';
